import _ from 'lodash';
import EditCropLink from '../components/EditCropLink';
import { asHours } from '../utils/formatters';
import { MULTI_YEAR } from './years';

export const getLaborMetrics = (showLink) => (category, year) => [
  {
    displayString: 'Activity',
    accessor: 'name',
    format: (name, op) =>
      showLink ? (
        <EditCropLink operation={op} crop={op.crop}>
          {name}
        </EditCropLink>
      ) : (
        name
      ),
  },
  {
    displayString:
      category === 'installation' || year !== MULTI_YEAR
        ? 'Total Hours'
        : 'Avg. Hours',
    accessor: 'displayLaborHours',
    format: asHours,
  },
  ...(category === null
    ? [
        {
          displayString: 'Category',
          accessor: 'category',
          format: _.capitalize,
        },
      ]
    : []),
];
